import {useContext, createContext} from 'react'

export const PopoverContext = createContext()

export const usePopoverContext = () => {
    const context = useContext(PopoverContext)
    if (!context) {
        throw new Error(
            "usePopoverContext must be used within a PopoverProvider. Please ensure all popover-related components are nested within 'PopoverContainer'"
        )
    }
    return context
}
